(function () {
  var CHM_GAUGE_CAP = 20;
  var DONATION_PER_ITEM = 2;
  var lastDonation = null;
  var pendingAdd = false;
  var refreshTimer = null;
  var toastTimer = null;

  function normalize(value) { return String(value || '').toLowerCase(); }
  function isSticker(item) {
    var type = normalize(item.product_type);
    var title = normalize(item.product_title || item.title);
    var handle = normalize(item.handle);
    return type.indexOf('autocollant') !== -1 || type.indexOf('sticker') !== -1 || title.indexOf('autocollant') !== -1 || title.indexOf('sticker') !== -1 || handle.indexOf('autocollant') !== -1 || handle.indexOf('sticker') !== -1;
  }
  function donationTotal(cart) {
    var eligibleQuantity = (cart.items || []).reduce(function (sum, item) { if (isSticker(item)) return sum; return sum + (Number(item.quantity) || 0); }, 0);
    return eligibleQuantity * DONATION_PER_ITEM;
  }
  function updateGauge(total) {
    var fillEl = document.querySelector('.chm-donation-bar__fill');
    var amountEl = document.querySelector('.chm-donation-bar__amount');
    if (!fillEl || !amountEl) return;
    fillEl.style.width = Math.min((total / CHM_GAUGE_CAP) * 100, 100) + '%';
    amountEl.textContent = total + ' €';
  }
  function updateCartImpact(total) {
    document.querySelectorAll('.cart-totals__container').forEach(function (container) {
      var host = container.parentElement || container;
      var row = host.querySelector('.chm-cart-impact');
      if (!row) { row = document.createElement('div'); row.className = 'chm-cart-impact'; row.innerHTML = '<span>Impact potentiel pour votre cause</span><strong></strong>'; container.insertAdjacentElement('afterend', row); }
      var value = row.querySelector('strong'); if (value) value.textContent = total + ' €';
    });
  }
  function showToast(delta) {
    if (delta <= 0) return;
    var toast = document.querySelector('.chm-impact-toast'); if (!toast) return;
    var amount = toast.querySelector('.chm-impact-toast__amount'); if (amount) amount.textContent = '+' + delta + ' € pour votre cause';
    window.clearTimeout(toastTimer); toast.hidden = false; window.requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    toastTimer = window.setTimeout(function () { toast.classList.remove('is-visible'); }, 2100);
  }
  function ensureCauseCheckout() {
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      if (ctas.querySelector('.chm-cause-checkout-link')) return;
      ctas.innerHTML = '<a href="/pages/choisissez-votre-cause" class="cart__checkout-button button chm-cause-checkout-link"><span class="button-text">Choisir ma cause et payer</span></a><p class="chm-cart-cause-note">2 € par article éligible, hors autocollants. Vous choisissez la cause avant le paiement.</p>';
    });
    if (!document.getElementById('chm-cart-cause-style')) {
      var style = document.createElement('style'); style.id = 'chm-cart-cause-style'; style.textContent = '.chm-cart-cause-note{margin:9px 0 0;font-size:11px;line-height:1.45;text-align:center;color:#666}.chm-cause-checkout-link{width:100%;text-decoration:none}'; document.head.appendChild(style);
    }
  }
  function applyCart(cart, animateIfAdded) {
    var total = donationTotal(cart); var previous = lastDonation;
    updateGauge(total); updateCartImpact(total); ensureCauseCheckout();
    if (animateIfAdded && previous !== null && total > previous) { showToast(total - previous); pendingAdd = false; }
    lastDonation = total;
  }
  function refreshFromCart(animateIfAdded) {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { if (!res.ok) throw new Error('Cart unavailable'); return res.json(); })
      .then(function (cart) { applyCart(cart, !!animateIfAdded); return cart; })
      .catch(function () {});
  }
  function scheduleRefresh(animateIfAdded, delay) { window.clearTimeout(refreshTimer); refreshTimer = window.setTimeout(function () { refreshFromCart(animateIfAdded); }, delay || 250); }

  document.addEventListener('DOMContentLoaded', function () {
    refreshFromCart(false); ensureCauseCheckout();
    if ('MutationObserver' in window) {
      var targets = [document.querySelector('cart-drawer'), document.querySelector('[ref="cartBubbleCount"]'), document.querySelector('.cart-bubble__text-count')].filter(Boolean);
      var observer = new MutationObserver(function () { scheduleRefresh(pendingAdd, 180); ensureCauseCheckout(); });
      targets.forEach(function (target) { observer.observe(target, { subtree: true, childList: true, characterData: true }); });
    }
  });
  ['cart:updated', 'cart:lines:update'].forEach(function (eventName) { document.addEventListener(eventName, function () { scheduleRefresh(pendingAdd, 120); }); });
  document.addEventListener('submit', function (event) {
    var form = event.target; if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    pendingAdd = true; window.setTimeout(function () { refreshFromCart(true); }, 450); window.setTimeout(function () { if (pendingAdd) refreshFromCart(true); }, 950); window.setTimeout(function () { pendingAdd = false; }, 1400);
  }, true);
  document.addEventListener('click', function (event) {
    var target = event.target.closest('a[href*="/checkout"],button[name="checkout"],input[name="checkout"]');
    if (!target || target.closest('[data-chm-cause-page]')) return;
    if (!target.closest('cart-drawer') && !target.closest('form[action*="/cart"]') && !target.closest('.cart__ctas')) return;
    event.preventDefault(); window.location.href = '/pages/choisissez-votre-cause';
  }, true);
})();